import React from 'react';
import PieDiagram from './PieDiagram';

const Distribution = () => {
  return (
    <div className="text-sm space-y-5">
      {/* Fila 1: Títulos */}
      <div className="flex justify-between">
        <div className="text-[#c1dbff] text-xl font-semibold w-[49%]">Distribución general de los activos</div>
        <div className="text-[#c1dbff] text-xl font-semibold w-[49%]">Detalles</div>
      </div>

      {/* Fila 2: Gráficos */}
      <div className="flex justify-between">
        <div className="bg-[#edf5fe] p-4 rounded-md w-[49%] flex items-center justify-center text-blue-900">
          <PieDiagram data={[
            { label: 'Acciones', value: 50 },
            { label: 'Bonos', value: 10 },
            { label: 'Commodities', value: 25 },
            { label: 'Líquido', value: 15 },
          ]} />
        </div>
        <div className="bg-[#edf5fe] p-4 rounded-md w-[49%] flex items-center justify-center text-blue-900">
          <PieDiagram data={[
            { label: 'BAN100', value: 40 },
            { label: 'DAVIVIENDA', value: 60 },
          ]} />
        </div>
      </div>

      {/* Fila 3: Etiquetas */}
      <div className="flex justify-between">
        <div className="bg-[#edf5fe] p-4 rounded-md w-[49%] flex flex-col justify-start">
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">Acciones</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>50%</span>
          </div>
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">Bonos</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>10%</span>
          </div>
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">Commodities</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>25%</span>
          </div>
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">Líquido</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>15%</span>
          </div>
        </div>
        <div className="bg-[#edf5fe] p-4 rounded-md w-[49%] flex flex-col justify-start">
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">BAN100</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>40%</span>
          </div>
          <div className="flex items-center text-blue-900 font-semibold">
            <span className="mr-2">DAVIVIENDA</span>
            <div className="flex-grow border-t border-dotted border-blue-900 mx-2" />
            <span>60%</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Distribution;
